/* jshint undef: true, unused: true */

var FoBuComponentFactory = require('./fobu-component-factory');

// REFACTOR: `inputwithbutton` should really be replaced with a  combo of an input and a button. That’s what it is there for after all…

module.exports = function component (componentSettings, foBu) {


  var componentFactory = new FoBuComponentFactory(componentSettings, foBu),
      componentObject  = componentFactory.getComponentObject(),
      element          = componentObject.element,
      wrapper          = componentObject.wrapper,
      dateWrapper      = document.createElement('div'),
      dateButton       = document.createElement('button'),
      dateFormat       = componentSettings.dateFormat();

  [componentSettings.comboWrapperClass, 'foBu__date-input-combo', 'foBu__form-item-child', 'combo--child'].forEach(function (className) {
    dateWrapper.classList.add(className);
  });
  ['foBu__form-item-child', 'foBu__form-item-child--input', 'combo--child', 'combo--first-child'].forEach(function (className) {
    element.classList.add(className);
  });
  ['foBu__date-input-button', 'foBu__form-item-child', 'foBu__form-item-child', 'combo--child', 'combo--last-child'].forEach(function (className) {
    dateButton.classList.add(className);
  });

  dateButton.setAttribute('type','button');
  dateWrapper.appendChild(element);
  dateWrapper.appendChild(dateButton);
  wrapper.appendChild(dateWrapper);

  $( element )
    .addClass('form-control')
    .datepicker({ dateFormat : dateFormat || 'dd/mm/yy'})
    .on('change', function() {
      foBu.validation.validateElement(foBu.settings.uid, element.foBuSettings.attributes.id);

    });

  dateButton.buttonTarget = element;

  foBu.manageEventListener(dateButton, 'click', function (event) {
    var buttonTarget = event.target.buttonTarget;

    event.stopPropagation();
    event.preventDefault();

    $(buttonTarget).datepicker('show');
  });

  element.classList.add(componentSettings.attributes.class);

  componentSettings.formId = foBu.settings.uid;

  componentSettings.domElement = element;
  componentSettings.domElement.foBuSettings = componentSettings;

  componentSettings.domWrapper = wrapper;

  return {
    wrapper           : wrapper,
    finaliseComponent : componentFactory.finaliseComponent
  };

};
